import { injectable } from 'inversify';
import 'reflect-metadata';
import { EmailRequest } from '../_api/models/email.model';
import axiosClient from './axios-client';
import { ContactFormRequest } from '../models/research/contact-form.model';
import { ApiResponse } from '../utils/api-response.utils';
import { ERRORS } from '../constants';

@injectable()
export class EmailService {
  async sendVerification(values: EmailRequest): Promise<ApiResponse<any>> {
    try {
      const response = await axiosClient.post<ApiResponse<any> | null>(
        '/api/email/send-verification',
        values
      );
      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async resendVerification(reqToken: string): Promise<ApiResponse<any>> {
    try {
      const response = await axiosClient.post<ApiResponse<any> | null>(
        '/api/email/resend-verification',
        { token: reqToken }
      );
      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async updateAccountVerification(id: number): Promise<ApiResponse<any>> {
    try {
      const response = await axiosClient.post<ApiResponse<any> | null>(
        '/api/email/update-account-verification/' + id
      );
      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async sendResetPassword(values: EmailRequest): Promise<ApiResponse<any>> {
    try {
      const response = await axiosClient.post<ApiResponse<any> | null>(
        '/api/email/send-reset-password',
        values
      );
      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async sendResearchContactForm(
    values: ContactFormRequest,
    userId: number
  ): Promise<ApiResponse<any>> {
    values.userId = userId;
    try {
      const response = await axiosClient.post<ApiResponse<any> | null>(
        '/api/email/send-research-contact-form',
        values
      );
      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }

  async sendContactUsForm(
    values: ContactFormRequest,
    userId: number
  ): Promise<ApiResponse<any>> {
    values.userId = userId;
    try {
      const response = await axiosClient.post<ApiResponse<any> | null>(
        '/api/email/send-contact-us-form',
        values
      );
      return response;
    } catch {
      throw new Error(ERRORS.unexpectedError);
    }
  }
}
